// extracted by mini-css-extract-plugin
export default {"Bottom":"Bottom_Bottom__G0Lel"};